import { Modal } from 'antd';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProps } from '../../../contextRedux/AccessControlDevice/AccessControlDeviceModel';
import { RootState } from '../../../store';
import AccessControlDeviceForm from '../AccessControlDeviceForm/AccessControlDeviceForm';

const AccessControlDeviceModal: FC<any> = () => {
  const dispatch = useDispatch();
  const reduxAccessControlDevice = useSelector((state: RootState) => state.models.accessControlDevice);

  return (
    <Modal
      title={!!reduxAccessControlDevice.id ? 'Modifica' : 'Adauga'}
      open={reduxAccessControlDevice.props.isModalVisible}
      onCancel={() => dispatch(updateProps({ field: 'isModalVisible', value: false }))}
      width={700}
      footer={null}
    >
      <AccessControlDeviceForm />
    </Modal>
  );
};

export default AccessControlDeviceModal;
